import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { StyleSheet, TouchableOpacity} from 'react-native';
import Theme from '../../theme';
import { changeNutritionView, closeAllModals, toggleFoodPreferencesModal } from '../../ui';
import { Icon } from '../../components';


class NutritionIconToggle extends React.Component {
    toggleFoodPreferencesModal = () => {
        const { isFoodPreferencesModalVisible } = this.props;
        this.props.toggleFoodPreferencesModal(!isFoodPreferencesModalVisible);
    }
    render() {
        const {
            size = 25,
            containerStyle = {},
        } = this.props;
        return (
            <TouchableOpacity
                style={[styles.container, containerStyle]}
                onPress={this.toggleFoodPreferencesModal}>
                <Icon
                    size={size}
                    color={Theme.GREY}
                    name="ios-settings-outline"
                />
            </TouchableOpacity>
        )
    }
}
const styles = StyleSheet.create({
    container: {
        alignItems: 'center',
        justifyContent: 'center',
    },
});

const mapStateToProps = (state, ownProps) => {
    const { nutritionView } = state.dashboard;
    return {
        nutritionView,
        navigation: ownProps.navigation,
        isMealModalVisible: state.ui.mealModalVisible,
        isFoodPreferencesModalVisible: state.ui.foodPreferencesModalVisible,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeNutritionView: (view) => dispatch(changeNutritionView(view)),
        closeModals: () => dispatch(closeAllModals()),
        toggleFoodPreferencesModal: (visible) => dispatch(toggleFoodPreferencesModal(visible)),
    };
};

NutritionIconToggle = connect(mapStateToProps, mapDispatchToProps)(NutritionIconToggle);
export default translate(['nutrition'], { wait: true })(NutritionIconToggle);

